/**
 * Shared constants and types for Corporate Actions feature
 * Extracted to avoid circular dependencies between formatter utilities and components
 */

// Shared constants for filter values to avoid fragile string coupling
export const STATUS_FILTER_OPTIONS = {
  ALL: 'All Status',
  UPCOMING: 'Upcoming',
  COMPLETED: 'Completed',
} as const;

export const TYPE_FILTER_OPTIONS = {
  ALL: 'All Types',
  CASH_DIVIDEND: 'Cash Dividend',
  STOCK_DIVIDEND: 'Stock Dividend',
  STOCK_SPLIT: 'Stock Split',
  REVERSE_STOCK_SPLIT: 'Reverse Stock Split',
} as const;

export type StatusFilterValue = (typeof STATUS_FILTER_OPTIONS)[keyof typeof STATUS_FILTER_OPTIONS];
export type TypeFilterValue = (typeof TYPE_FILTER_OPTIONS)[keyof typeof TYPE_FILTER_OPTIONS];
